/* ============================================================
   PRODUCT HERO — Section 1
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  /* ── Image cycling ──────────────────────────────────────────── */

  function initImages() {
    var hero = document.querySelector('.js-product-hero');
    if (!hero) return null;

    var items   = Array.from(hero.querySelectorAll('.js-ph-item'));
    var dots    = Array.from(hero.querySelectorAll('.js-ph-dot'));
    var current = 0;

    function goTo(idx) {
      if (!items.length) return;

      var next = Math.max(0, Math.min(idx, items.length - 1));
      if (next === current) return;

      items[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = next;
      items[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    /* ── Touch swipe ─────────────────────────────────────────────── */
    var mediaWrap   = hero.querySelector('.js-ph-media');
    var touchStartX = 0;
    var touchStartY = 0;
    if (mediaWrap && items.length > 1) {
      mediaWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      mediaWrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
        if (dx < 0) goTo(current + 1);
        else         goTo(current - 1);
      }, { passive: true });
    }

    return {
      hero: hero,
      count: items.length,
      getCurrent: function () { return current; },
      goTo: goTo
    };
  }

  function getRenderedProductSections() {
    return [
      document.querySelector('.js-product-hero'),
      document.querySelector('.perfume-notes'),
      document.querySelector('.char-inspiration'),
      document.querySelector('.perfumer'),
      document.querySelector('.js-site-footer')
    ].filter(function (section) {
      return section && getComputedStyle(section).display !== 'none';
    });
  }

  function getSectionDocumentTop(section) {
    return section.getBoundingClientRect().top + window.scrollY;
  }

  function getProductHeroStart(hero) {
    var spacer = hero.parentElement;
    if (spacer && spacer.classList.contains('pin-spacer')) {
      return spacer.getBoundingClientRect().top + window.scrollY;
    }
    return getSectionDocumentTop(hero);
  }

  function getProductHeroEnd(hero) {
    var spacer = hero.parentElement;
    if (spacer && spacer.classList.contains('pin-spacer')) {
      return getProductHeroStart(hero) + spacer.offsetHeight;
    }
    return getSectionDocumentTop(hero) + hero.offsetHeight;
  }

  function waitForGSAP(callback) {
    var attempts = 0;
    var maxAttempts = 80;

    function check() {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        callback(true);
        return;
      }

      attempts += 1;
      if (attempts >= maxAttempts) {
        callback(false);
        return;
      }

      window.setTimeout(check, 80);
    }

    check();
  }

  function initMobileProductHeaderState(hero) {
    if (window.__productMobileHeaderStateInitialized) return;
    window.__productMobileHeaderStateInitialized = true;

    function sync() {
      if (window.innerWidth > 768) return;

      var sections = getRenderedProductSections();
      if (!sections.length) return;

      var probe = window.scrollY + (window.innerHeight * 0.5);
      var active = sections[0];

      sections.forEach(function (section, index) {
        var top = section === hero ? getProductHeroStart(hero) : getSectionDocumentTop(section);
        var bottom = sections[index + 1]
          ? (sections[index + 1] === hero
            ? getProductHeroStart(hero)
            : getSectionDocumentTop(sections[index + 1]))
          : top + section.offsetHeight;

        if (probe >= top && probe < bottom) active = section;
      });

      var mode = active.classList.contains('char-inspiration') ||
        active.classList.contains('perfumer') ||
        active.classList.contains('site-footer') ? 'light' : 'dark';

      if (document.body.dataset.productHeaderColor !== mode) {
        document.body.dataset.productHeaderColor = mode;
      }
    }

    var scheduled = false;
    function scheduleSync() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sync();
      });
    }

    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleSync);
    scheduleSync();
  }

  function initProductScrollStateMachine(imageController) {
    if (!document.body.classList.contains('template-product')) return;
    if (!imageController || !imageController.hero) return;
    if (window.__productScrollStateMachineInitialized) return;
    window.__productScrollStateMachineInitialized = true;

    var hero = imageController.hero;
    var heroPin = null;
    var inputReady = window.innerWidth <= 768 || imageController.count < 2;
    var states = [];
    var stateIndex = 0;
    var isAnimating = false;
    var wheelAccumulator = 0;
    var cooldownUntil = 0;
    var resizeTimer = null;

    var WHEEL_THRESHOLD = 90;
    var FOOTER_CLASSES = ['site-footer', 'js-site-footer'];

    function getMaxScroll() {
      return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    }

    function isSection(section, className) {
      return section.classList.contains(className);
    }

    function getStateKey(state) {
      if (state.kind === 'hero') return 'hero:' + state.imageIndex;
      return state.element;
    }

    function buildStates() {
      var currentKey = states[stateIndex] ? getStateKey(states[stateIndex]) : 'hero:0';
      var nextStates = [];
      var heroStateCount = window.innerWidth > 768 ? Math.max(1, imageController.count) : 1;

      for (var imageIndex = 0; imageIndex < heroStateCount; imageIndex += 1) {
        nextStates.push({ kind: 'hero', imageIndex: imageIndex });
      }

      getRenderedProductSections().forEach(function (section) {
        if (section === hero) return;
        nextStates.push({ kind: 'section', element: section });
      });

      states = nextStates;
      var matchingIndex = states.findIndex(function (state) {
        return getStateKey(state) === currentKey;
      });
      stateIndex = matchingIndex >= 0 ? matchingIndex : Math.min(stateIndex, states.length - 1);
      if (stateIndex < 0) stateIndex = 0;
    }

    function getStateTarget(state) {
      if (!state) return 0;

      if (state.kind === 'hero') {
        if (!heroPin || window.innerWidth <= 768 || imageController.count < 2) {
          return getProductHeroStart(hero);
        }

        var step = Math.round(window.innerHeight * 0.7);
        return Math.min(
          getProductHeroStart(hero) + (step * state.imageIndex),
          getProductHeroEnd(hero)
        );
      }

      var section = state.element;
      var sectionTop = getSectionDocumentTop(section);
      var target = sectionTop;

      if (isSection(section, 'perfume-notes')) {
        /* Notes are centered where possible, but never pulled back into the Hero pin range. */
        var spareHeight = Math.max(0, window.innerHeight - section.offsetHeight);
        target = sectionTop - (spareHeight / 2);
        target = Math.max(getProductHeroEnd(hero), target);
      } else if (FOOTER_CLASSES.some(function (className) { return isSection(section, className); })) {
        target = getMaxScroll();
      }

      return Math.max(0, Math.min(target, getMaxScroll()));
    }

    function setHeaderState(state) {
      var mode = 'dark';
      if (state && state.kind === 'section' && !isSection(state.element, 'perfume-notes')) {
        mode = 'light';
      }
      document.body.dataset.productHeaderColor = mode;
    }

    function refreshStateLayout() {
      buildStates();
      setHeaderState(states[stateIndex]);

      if (!isAnimating) {
        var target = getStateTarget(states[stateIndex]);
        if (Math.abs(window.scrollY - target) > 4) window.scrollTo(0, target);
      }
    }

    function animateTo(target, onComplete) {
      var start = window.scrollY;
      var distance = target - start;
      var duration = Math.min(720, Math.max(420, Math.abs(distance) * 0.45));
      var startedAt = performance.now();
      var root = document.documentElement;
      var previousScrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';

      function ease(t) {
        return t < 0.5 ? 2 * t * t : 1 - (Math.pow(-2 * t + 2, 2) / 2);
      }

      function frame(now) {
        var progress = Math.min(1, (now - startedAt) / duration);
        window.scrollTo(0, start + (distance * ease(progress)));
        if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.update) ScrollTrigger.update();

        if (progress < 1) {
          requestAnimationFrame(frame);
          return;
        }

        root.style.scrollBehavior = previousScrollBehavior;
        onComplete();
      }

      requestAnimationFrame(frame);
    }

    function advance(direction) {
      if (!inputReady || isAnimating || !states.length) return;
      if (performance.now() < cooldownUntil) return;

      var nextIndex = Math.max(0, Math.min(states.length - 1, stateIndex + direction));
      if (nextIndex === stateIndex) return;

      wheelAccumulator = 0;
      stateIndex = nextIndex;
      setHeaderState(states[stateIndex]);

      if (states[stateIndex].kind === 'hero') {
        imageController.goTo(states[stateIndex].imageIndex);
      }

      isAnimating = true;
      animateTo(getStateTarget(states[stateIndex]), function () {
        isAnimating = false;
        wheelAccumulator = 0;
        cooldownUntil = performance.now() + 480;
        setHeaderState(states[stateIndex]);
      });
    }

    function normalizeWheelDelta(event) {
      var delta = event.deltaY;
      if (event.deltaMode === 1) delta *= 40;
      if (event.deltaMode === 2) delta *= window.innerHeight;
      return delta;
    }

    function handleWheel(event) {
      if (window.innerWidth <= 768) return;

      event.preventDefault();
      event.stopPropagation();

      if (!inputReady || isAnimating || performance.now() < cooldownUntil) {
        wheelAccumulator = 0;
        return;
      }

      var delta = normalizeWheelDelta(event);
      if (!delta) return;

      if (wheelAccumulator && Math.sign(wheelAccumulator) !== Math.sign(delta)) {
        wheelAccumulator = 0;
      }

      wheelAccumulator += delta;
      if (Math.abs(wheelAccumulator) < WHEEL_THRESHOLD) return;

      var direction = wheelAccumulator > 0 ? 1 : -1;
      wheelAccumulator = 0;
      advance(direction);
    }

    function isEditableTarget(target) {
      return target && (
        target.matches('input, textarea, select, button, [contenteditable="true"]') ||
        target.closest('input, textarea, select, button, [contenteditable="true"]')
      );
    }

    function handleKeydown(event) {
      if (window.innerWidth <= 768) return;
      if (isEditableTarget(event.target)) return;

      var direction = 0;
      if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === ' ') direction = 1;
      if (event.key === 'ArrowUp' || event.key === 'PageUp') direction = -1;
      if (!direction) return;

      event.preventDefault();
      event.stopPropagation();
      wheelAccumulator = 0;
      advance(direction);
    }

    function handleScroll() {
      if (window.innerWidth <= 768) return;
      if (!inputReady || isAnimating || !states.length) return;
      var target = getStateTarget(states[stateIndex]);
      if (Math.abs(window.scrollY - target) > 6) window.scrollTo(0, target);
    }

    function reconcileHeroPin() {
      var shouldPin = window.innerWidth > 768 && imageController.count > 1;

      if (!shouldPin && heroPin) {
        heroPin.kill();
        heroPin = null;
      }

      if (window.innerWidth <= 768) {
        inputReady = false;
        return;
      }

      if (!shouldPin) {
        inputReady = true;
        refreshStateLayout();
        return;
      }

      if (heroPin) {
        inputReady = true;
        ScrollTrigger.refresh();
        refreshStateLayout();
        return;
      }

      inputReady = false;
      waitForGSAP(function (hasGSAP) {
        if (hasGSAP) {
          var step = Math.round(window.innerHeight * 0.7);
          heroPin = ScrollTrigger.create({
            trigger: hero,
            pin: true,
            start: 'top top',
            end: '+=' + (step * (imageController.count - 1))
          });
          ScrollTrigger.refresh();
        }

        inputReady = true;
        refreshStateLayout();
      });
    }

    function handleResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        reconcileHeroPin();
      }, 60);
    }

    buildStates();
    setHeaderState(states[stateIndex]);
    window.addEventListener('wheel', handleWheel, { passive: false, capture: true });
    window.addEventListener('keydown', handleKeydown, { capture: true });
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });

    reconcileHeroPin();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (heroPin && typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        if (window.innerWidth > 768) refreshStateLayout();
      });
    }
  }

  /* ── Quantity Selector ──────────────────────────────────────── */

  function initQuantity() {
    var form = document.querySelector('.js-ph-form');
    if (!form) return;

    var qtyInput  = form.querySelector('.js-ph-qty-input');
    var qtyNum    = form.querySelector('.js-ph-qty-num');
    var btnPlus   = form.querySelector('.js-ph-qty-plus');
    var btnMinus  = form.querySelector('.js-ph-qty-minus');

    if (!qtyInput || !qtyNum || !btnPlus || !btnMinus) return;

    var qty = 1;

    function setQty(n) {
      qty                    = Math.max(1, n);
      qtyNum.textContent     = qty;
      qtyInput.value         = qty;
      btnMinus.style.opacity = qty <= 1 ? '0.25' : '';
    }

    btnPlus.addEventListener('click',  function () { setQty(qty + 1); });
    btnMinus.addEventListener('click', function () { setQty(qty - 1); });
  }

  /* ── AJAX Add to Cart ───────────────────────────────────────── */

  function initAddToCart() {
    if (document.body.classList.contains('is-sales-disabled')) return;

    var form = document.querySelector('.js-ph-form');
    if (!form) return;

    var atcBtn    = form.querySelector('.js-ph-atc');
    var atcText   = atcBtn && atcBtn.querySelector('.product-hero__atc-text');
    var variantEl = form.querySelector('.js-ph-variant');
    var qtyInput  = form.querySelector('.js-ph-qty-input');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!variantEl || !atcBtn || atcBtn.disabled) return;

      var variantId = variantEl.value;
      var quantity  = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
      var original  = atcText ? atcText.textContent : 'Add to Cart';

      atcBtn.classList.add('is-adding');
      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (atcText) atcText.textContent = 'Added!';

          var cartToggle = document.querySelector('.js-cart-toggle');
          if (cartToggle) cartToggle.click();
          if (window.__refreshCartCount) window.__refreshCartCount();

          setTimeout(function () {
            if (atcText) atcText.textContent = original;
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-adding');
          }, 1400);
        })
        .catch(function () {
          if (atcText) atcText.textContent = 'Please try again';
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-adding');
          setTimeout(function () {
            if (atcText) atcText.textContent = original;
          }, 2200);
        });
    });
  }

  /* ── Mobile: hide purchase box when footer is visible ──────── */

  function initMobilePurchasePin() {
    var purchaseWrap = document.querySelector('.product-hero__purchase-wrap');
    var footer       = document.querySelector('.js-site-footer') || document.querySelector('.site-footer');

    if (!purchaseWrap || !footer) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        purchaseWrap.classList.toggle('is-footer-visible', entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(footer);
  }

  /* ── Init ───────────────────────────────────────────────────── */

  function init() {
    var imageController = initImages();
    if (imageController && document.body.classList.contains('template-product')) {
      initMobileProductHeaderState(imageController.hero);
    }
    initProductScrollStateMachine(imageController);
    initQuantity();
    initAddToCart();
    initMobilePurchasePin();

    /* Reveal hero — DOM is ready, layout is applied, no FOUC */
    var hero = document.querySelector('.product-hero');
    if (hero) hero.classList.add('is-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
